import { useLocation } from "react-router-dom";

//Once we upgrade to react-router v6, we can use useSearchParams
export function useQueryString(): URLSearchParams {
    const { search } = useLocation();

    return new URLSearchParams(search);
}